import BaseOutgoingPayload from "./base-outgoing-payload.ts";
import OutgoingPayloadEvent from "../../enums/outgoing-payload-event.ts";

export default class V1GroupRestaurantPreferences extends BaseOutgoingPayload {
  public readonly payload: V1GroupRestaurantPreferencesPayload;

  constructor(restaurantPreferences: string[]) {
    super(OutgoingPayloadEvent.V1_GROUP_RESTAURANT_PREFERENCES);
    this.payload = new V1GroupRestaurantPreferencesPayload(restaurantPreferences);
  }
}

class V1GroupRestaurantPreferencesPayload {
  public readonly restaurant_preferences: string[];

  constructor(restaurant_preferences: string[]) {
    this.restaurant_preferences = restaurant_preferences;
  }
}
